import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from "@common/models"
import { StringUtility } from "@common/utils";

export interface ICommunicationPreferenceModel extends IModel {
    canSMS: boolean;
    canSMSDateUpdated: DateTime | undefined;
    canSMSUpdatedUserTitle: string;
    canSMSUpdatedUserFirstName: string;
    canSMSUpdatedUserLastName: string;
    canCall: boolean;
    canCallDateUpdated: DateTime | undefined;
    canCallUpdatedUserTitle: string;
    canCallUpdatedUserFirstName: string;
    canCallUpdatedUserLastName: string;
    storeTimeZone: string;
    phoneNumber: string;
}

export class CommunicationPreferenceModel extends Model implements ModelRecord<ICommunicationPreferenceModel> {
    canSMS: boolean;
    canSMSDateUpdated: DateTime | undefined;
    canSMSUpdatedUserTitle: string;
    canSMSUpdatedUserFirstName: string;
    canSMSUpdatedUserLastName: string;
    canCall: boolean;
    canCallDateUpdated: DateTime | undefined;
    canCallUpdatedUserTitle: string;
    canCallUpdatedUserFirstName: string;
    canCallUpdatedUserLastName: string;
    storeTimeZone: string;
    phoneNumber: string;
    constructor(params?: Partial<ICommunicationPreferenceModel>) {
        super(params);
        this.canSMS = _.defaultTo(params?.canSMS, true);
        this.canSMSDateUpdated = params?.canSMSDateUpdated ? StringUtility.SanitizeDateTimeISOAsUtc(params?.canSMSDateUpdated.toString()) : undefined;
        this.canSMSUpdatedUserTitle = _.defaultTo(params?.canSMSUpdatedUserTitle, '');
        this.canSMSUpdatedUserFirstName = _.defaultTo(params?.canSMSUpdatedUserFirstName, '');
        this.canSMSUpdatedUserLastName = _.defaultTo(params?.canSMSUpdatedUserLastName, '');
        this.canCall = _.defaultTo(params?.canCall, true);
        this.canCallDateUpdated = params?.canCallDateUpdated ? StringUtility.SanitizeDateTimeISOAsUtc(params?.canCallDateUpdated.toString()) : undefined;
        this.canCallUpdatedUserTitle = _.defaultTo(params?.canCallUpdatedUserTitle, '');
        this.canCallUpdatedUserFirstName = _.defaultTo(params?.canCallUpdatedUserFirstName, '');
        this.canCallUpdatedUserLastName = _.defaultTo(params?.canCallUpdatedUserLastName, '');
        this.storeTimeZone = _.defaultTo(params?.storeTimeZone, '');
        this.phoneNumber = _.defaultTo(params?.phoneNumber, '');
    }

    get canCallFullName() {
        if (this.canCallUpdatedUserFirstName && this.canCallUpdatedUserLastName)
            return StringUtility.formattedUserName(this.canCallUpdatedUserFirstName, this.canCallUpdatedUserLastName, this.canCallUpdatedUserTitle);
        else
            return undefined
    }
    get canSMSFullName() {
        if (this.canSMSUpdatedUserFirstName && this.canSMSUpdatedUserLastName)
            return StringUtility.formattedUserName(this.canSMSUpdatedUserFirstName, this.canSMSUpdatedUserLastName, this.canSMSUpdatedUserTitle);
        else
            return undefined
    }
}
